import type { TFunction } from 'i18next'
// TODO: Refactor
import type { TabValues } from 'libs/pages/room-offer/src/lib/types/TabValues.ts'

import type { Offer } from '@wwt/entities/search-response'

import { ALLOW_SHOW_RESERVATION_TAB } from '../config/allowShowReservationTab.ts'
import { ReservationTab } from '../ui/ReservationTab'

export const generateReservationTab = (
	offer: Offer | null,
	t: TFunction<'room-page'>
): TabValues[] => {
	if (offer === null) return []

	const status = offer.IDs.status

	if (ALLOW_SHOW_RESERVATION_TAB.includes(status)) {
		const tabName = t('reservationVoucherTab')

		return [
			{
				label: tabName,
				props: { offer },
				component: ReservationTab,
				hint: t('tabHint', { tabName })
			}
		]
	}

	return []
}
